import axiosInstance from '../axiosInstance';
import {
  IExternalLinkPayload,
  IExternalLoginPayload,
  IGoogleSettings,
  ILoginReqPayload,
  ILoginResponse,
  IMicrosoftSettings,
  IRefreshTokenReqPayload,
} from './types';
import { requestResources } from '../requestResources';
import { IResponse } from '../types';
import { IForgotPasswordInitialValues } from 'pages/Login/form';
import { IPusherConfig } from 'services/chats/types';

const { clientPortalAuth, clientPortalPasswordRecovery } = requestResources;

export const login = (payload: ILoginReqPayload): IResponse<ILoginResponse> =>
  axiosInstance.post(`${clientPortalAuth}`, payload);

export const forgotPassword = (payload: IForgotPasswordInitialValues): IResponse<boolean> =>
  axiosInstance.post(`${clientPortalAuth}/forgotPassword`, payload);

export const refreshToken = (payload: IRefreshTokenReqPayload): IResponse<ILoginResponse> =>
  axiosInstance.put(`${clientPortalAuth}`, payload);

export const recoveryCodeVerification = (code: string): IResponse<{ userName: string }> =>
  axiosInstance.get(`${clientPortalPasswordRecovery}/verify?code=${code}`);

export const recoverPassword = (payload: { code: string; password: string }): IResponse<any> =>
  axiosInstance.post(`${clientPortalPasswordRecovery}/recovery`, payload);

export const getMicrosoftSettings = (): IResponse<IMicrosoftSettings> =>
  axiosInstance.get(`${clientPortalAuth}/get-msal-settings`);

export const getGoogleSettings = (): IResponse<IGoogleSettings> =>
  axiosInstance.get(`${clientPortalAuth}/get-google-api-settings`);

export const linkAccount = (payload: IExternalLinkPayload): IResponse<boolean> =>
  axiosInstance.put(`${clientPortalAuth}/LinkAccount`, payload);

export const getPusherAuthSettings = (): IResponse<IPusherConfig> =>
  axiosInstance.get(`${clientPortalAuth}/get-auth-pusher-settings`);

export const unlinkAccount = (type: number): IResponse<boolean> =>
  axiosInstance.put(`${clientPortalAuth}/UnLinkAccount/${type}`);

export const externalLogin = (payload: IExternalLoginPayload): IResponse<ILoginResponse> =>
  axiosInstance.post(`${clientPortalAuth}/ExternalLogin`, payload);

export const teamsAutoLogin = (payload: { userId: string; userPrincipal: string }): IResponse<ILoginResponse> =>
  axiosInstance.post(`${clientPortalAuth}/AutoLogin`, payload)
